export const configButtons = {
    like:{
        notclicked: {
            normal: 'CalificadorContenidos_Boton_MeGusta_Icono_Estado1',
            focus: 'CalificadorContenidos_Boton_MeGusta_Icono_Estado2',
            textKey: 'CalificadorContenidos_Boton_MeGusta_Texto',
            textLength: 11
        },
        clicked: {
            normal: 'CalificadorContenidos_Boton_TeGusta_Icono_Estado1',
            focus: 'CalificadorContenidos_Boton_TeGusta_Icono_Estado2',
            textKey: 'CalificadorContenidos_Boton_TeGusta_Texto',
            textLength: 11
        }
    },
    loveit:{
        notclicked: {
            normal: 'CalificadorContenidos_Boton_MeEncanta_Icono_Estado1',
            focus: 'CalificadorContenidos_Boton_MeEncanta_Icono_Estado2',
            textKey: 'CalificadorContenidos_Boton_MeEncanta_Texto',
            textLength: 11
        },
        clicked: {
            normal: 'CalificadorContenidos_Boton_TeEncanta_Icono_Estado1',
            focus: 'CalificadorContenidos_Boton_TeEncanta_Icono_Estado2',
            textKey: 'CalificadorContenidos_Boton_TeEncanta_Texto',
            textLength: 11
        }
    },
    dislike:{
        notclicked: {
            normal: 'CalificadorContenidos_Boton_NoMeGusta_Icono_Estado1',
            focus: 'CalificadorContenidos_Boton_NoMeGusta_Icono_Estado2',
            textKey: 'CalificadorContenidos_Boton_NoMeGusta_Texto',
            textLength: 11
        },
        clicked: {
            normal: 'CalificadorContenidos_Boton_NoTeGusta_Icono_Estado1',
            focus: 'CalificadorContenidos_Boton_NoTeGusta_Icono_Estado2',
            textKey: 'CalificadorContenidos_Boton_NoTeGusta_Texto',
            textLength: 11
        }
    },
    close:{
        normal: 'CalificadorContenidos_Boton_Cerrar_Icono_Estado1',
        focus: 'CalificadorContenidos_Boton_Cerrar_Icono_Estado2',
        textKey: 'CalificadorContenidos_Boton_Cerrar_Texto',
        textLength: 6
    }
}

export const typeButtons = {
    like: 'like',
    loveit: 'loveit',
    dislike: 'dislike',
    error: 'error'
}

export const ratingValues = {
    like: 1,
    loveit: 2,
    dislike : -1,
};

export const configNotifications = {
    like: {
        title: {
            Key: 'Calificador_Notificacion_TeGusta_Texto_Titulo',
            length: 69
        },
        message: {
            Key: 'Calificador_Notificacion_TeGusta_TextoSubtitulo',
            length: 149
        },
        icon: {
            Key: 'Calificador_Notificacion_TeGusta_Icono'
        }
    },
    loveit: {
        title: {
            Key: 'Calificador_Notificacion_TeEncanta_Texto_Titulo',
            length: 69
        },
        message: {
            Key: 'Calificador_Notificacion_TeEncanta_Texto_Subtitulo',
            length: 149
        },
        icon: {
            Key: 'Calificador_Notificacion_TeEncanta_Icono'
        }
    },
    dislike: {
        title: {
            Key: 'Calificador_Notificacion_NoTeGusta_Texto_Titulo',
            length: 69
        },
        message: {
            Key: 'Calificador_Notificacion_NoTeGusta_Texto_Subtitulo',
            length: 149
        },
        icon: {
            Key: 'Calificador_Notificacion_NoTeGusta_Icono'
        }
    },
   error: {
        title: {
            Key: 'Calificador_Notificacion_Error_Texto_Titulo',
            length: 69
        },
        message: {
            Key: 'Calificador_Notificacion_Error_Texto_Subtitulo',
            length: 149
        },
        icon: {
            Key: 'Calificador_Notificacion_Error_Icono',
            styles: { width: '100%', height: '100%' }
        }
    },
}

export const EVENT_ERROR = 'event_error';

export const INTERACTION_PLAYER = 'interaction_player';


// WEBPACK FOOTER //
// ./src/components/Modal/ratingContent/constants.js